import { string } from 'prop-types';
import Link from 'next/link';
import { MailOutlinedSVG } from 'components/iconsSVG/mailOutline';
import { PhoneOutlineSVG } from 'components/iconsSVG/phoneOutline';

import { useI18n } from 'context/i18n';
import { getMarket } from 'utils/helpers';

import styles from './style.module.css';

export const ContactBlock = (placement) => {
  const { t, locale, profileData } = useI18n();
  const market = getMarket(locale);
  const hidePhoneNumbers = profileData?.config?.hide_telephone_numbers ?? false;
  if (hidePhoneNumbers) return null;

  const title = placement === 'bottom' ?
    <h2>{t('contacto', 'ayuda.titulo', 'Need Help?')}</h2> :
    <p>{t('contacto', 'ayuda.titulo', 'Need Help?')}</p>;

  return (
    <div className={styles.contactWrapper}>
      {title}
      <div className={styles.contactWrapperInfo}>
          {
            profileData?.phone && <>
              <div>
                <PhoneOutlineSVG/>
              </div>
              <div>
                <p className={styles.infoUnderline}>
                  <a href={`tel:${profileData.phone}`}><u> {profileData.phone}</u></a>
                </p>
                <p dangerouslySetInnerHTML={{ __html: t('menu.derecha', `derecha.contacta.horario.${market.toLowerCase()}`).replace(/(?:\r\n|\r|\n)/g, '<br />') }}></p>
              </div>
            </>
          }
          <div>
            <MailOutlinedSVG />
          </div>
          <div>
            <Link prefetch={false} href={`/${locale}/contacto`}>
              <p className={styles.infoUnderline}>{t('contacto', 'ayuda.email', 'Contact by e-mail')}</p>
            </Link>
          </div>
      </div>
    </div>
  );
};

ContactBlock.propTypes = {
  placement: string,
};
ContactBlock.defaultProps = {
  placement: 'right',
};
